import React from 'react';
import { LuTriangleAlert } from 'react-icons/lu';
import Button from '../Button/Button';
import './ErrorState.less';

function ErrorState({
  title = 'Something went wrong',
  description = 'Please try again.',
  onRetry,
  retryLabel = 'Try again',
}) {
  return (
    <div className="gc-error-state" role="alert">
      <div className="gc-error-state-icon" aria-hidden="true"><LuTriangleAlert /></div>
      <h3 className="gc-error-state-title">{title}</h3>
      {description && <p className="gc-error-state-desc">{description}</p>}
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>{retryLabel}</Button>
      )}
    </div>
  );
}

export default ErrorState;
